// src/services/Meetupsdtlbannersec.js
import { API_URL, API_TOKEN } from "../api/apiConfig";

export const fetchCommunitydetail = async (id) => {
  try {
    const response = await fetch(`${API_URL}/travelcommunity_detail`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id }),
    });

    return await response.json();
  } catch (error) {
    console.log("API Error:", error);
    return null;
  }
};